<script>
export default {
  props: {
    current: {
      type: String,
      required: true
    },
    transaction: {
      type: String,
      required: true
    }
  }
}
</script>
<template>
  <a-menu mode="horizontal" :selected-keys="[current]">
    <a-menu-item key="hyperion.transaction.show">
      <a :href="routeUri('hyperion.transaction.show', { transaction_uuid: transaction })">
        <a-icon type="project"/>
        Overview
      </a>
    </a-menu-item>

    <a-menu-item key="hyperion.transaction.biller-response">
      <a :href="routeUri('hyperion.transaction.biller-response', {transaction_uuid: transaction })">
        <a-icon type="deployment-unit"/>
        Biller Response
      </a>
    </a-menu-item>

    <a-menu-item key="hyperion.transaction.inbound">
      <a :href="routeUri('hyperion.transaction.inbound', { transaction_uuid: transaction })">
        <a-icon type="shrink"/>
        Inbound
      </a>
    </a-menu-item>

    <a-menu-item key="hyperion.transaction.outbound">
      <a :href="routeUri('hyperion.transaction.outbound', {transaction_uuid: transaction})">
        <a-icon type="arrows-alt"/>
        Outbound
      </a>
    </a-menu-item>


    <a-menu-item key="hyperion.transaction.source">
      <a :href="routeUri('hyperion.transaction.source', { transaction_uuid: transaction })">
        <a-icon type="code"/>
        Source
      </a>
    </a-menu-item>
  </a-menu>
</template>
